/** Whole dollars available to withdraw (floor in-game balance, e.g. $11.8 → $11). */
export function getWithdrawableIntegerBalance(balance: number): number {
  if (!Number.isFinite(balance) || balance <= 0) return 0;
  return Math.floor(balance);
}

/** Whole dollars for UI display (floor, e.g. $89.56 → $89). */
export function getDisplayIntegerDollars(balance: number): number {
  return getWithdrawableIntegerBalance(balance);
}

export function isRiverPayProviderCode(code: string | undefined): boolean {
  return (code || '').toLowerCase().replace(/\s+/g, '').replace(/-/g, '') === 'riverpay';
}

/**
 * Max integer withdraw amount per provider.
 * River Pay: redeemable `winning` only; other games: in-game balance.
 */
export function getMaxGameWithdrawAmount(
  providerCode: string | undefined,
  inGameBalance: number,
  winningBalance: number,
): number {
  if (isRiverPayProviderCode(providerCode)) {
    return getWithdrawableIntegerBalance(winningBalance);
  }
  return getWithdrawableIntegerBalance(inGameBalance);
}

/**
 * Next amount after one (+) click: increment by `step`, snap to integer `max` on the final partial step.
 */
export function getNextAmountAfterIncrement(
  current: number,
  step: number,
  max: number
): number {
  const maxInt = getWithdrawableIntegerBalance(max);
  const currentInt = Math.max(0, Math.floor(current));
  if (currentInt >= maxInt || step <= 0) return currentInt;
  return Math.min(currentInt + step, maxInt);
}
